module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(14).90d1f699.png";